import { useWalletFlag } from 'src/pages/Wallet/hooks/useWalletFlag';
import { useWalletSurfaceAccess } from 'src/pages/Wallet/hooks/useWalletSurfaceAccess';
import { tMetaErrorNoticeBillingCohort } from 'src/utils/metaErrorNotice.types';

/**
 * RET-2256: the billing cohort a Meta error notice's body should speak in,
 * read once through the wallet's single gate (`useWalletFlag`). Never
 * `isLoadingWalletFlag` — only `hasLoadedWalletFlag` is keyed by workspace
 * (see its docblock), so it is the only one safe for a visibility/wording
 * decision.
 *
 * Both renderers that translate a notice's body (chat's
 * `CatalogMetaErrorNotice` and campaigns' `useCatalogFailureCopy`) call this
 * hook instead of reading `useWalletFlag` themselves, so the flag → cohort
 * mapping exists once.
 *
 * RET-2339: a workspace KNOWN to have no WhatsApp API (`isKnownWithoutWapiAccess`,
 * positive evidence only) gets `'noWapiAccess'`, whatever the wallet flag says
 * and whether or not it has loaded: it has no balance or credits to name.
 * Every other case is unchanged.
 */
export function useMetaErrorNoticeBillingCohort(): tMetaErrorNoticeBillingCohort {
  const { hasLoadedWalletFlag, isWalletEnabled } = useWalletFlag();
  const { isKnownWithoutWapiAccess } = useWalletSurfaceAccess();

  if (isKnownWithoutWapiAccess) return 'noWapiAccess';
  if (!hasLoadedWalletFlag) return 'unresolved';
  return isWalletEnabled ? 'wallet' : 'credits';
}
